/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable react/no-danger */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Cards from '../lists/Cards';

import styles from '../../../styles/blocks/stats.module.scss';

const propTypes = {
    title: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
        }),
    ),
    small: PropTypes.bool,
    align: PropTypes.oneOf(['left', 'center', 'right']),
    className: PropTypes.string,
    titleClassName: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    title: null,
    items: null,
    small: true,
    align: null,
    className: null,
    isContainer: false,
    titleClassName: null,
    containerClassName: null,
};

const StatsBlock = ({
    title,
    items,
    small,
    align,
    className,
    isContainer,
    titleClassName,
    containerClassName,
}) => {
    const cardsRef = useRef();
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [containerClassName]: containerClassName !== null,
                },
            ])}
        >
            <div
                className={classNames([
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                    },
                ])}
            >
                {title !== null ? (
                    <div
                        className={classNames([
                            styles.title,
                            {
                                [titleClassName]: titleClassName !== null,
                            },
                        ])}
                    >
                        {title}
                    </div>
                ) : null}
                <div
                    className={classNames([
                        styles.items,
                        {
                            [styles.withTitle]: title !== null,
                            [styles[align]]: align !== null,
                        },
                    ])}
                >
                    <Cards
                        className={classNames([
                            styles.cards,
                            {
                                [styles.scrollable]: false,
                            },
                        ])}
                        cardClassName={styles.card}
                        size={small ? 'small' : 'large'}
                        items={items}
                        itemType="stat"
                        ref={cardsRef}
                        // onScroll={onSliderScroll}
                        // theme="mystery"
                        visible
                    />
                </div>
            </div>
        </div>
    );
};

StatsBlock.propTypes = propTypes;
StatsBlock.defaultProps = defaultProps;

export default StatsBlock;
